import React, { Component } from "react";

class ChildBenefits extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <section className="child-detail__item child-detail__benefits">
        <p className="benefits__title beta text-center">What your sponsored child gets</p>
        <div className="benefits__item media">
          <div className="media__img">
            <img className="benefits-item__image" src="https://wvusstatic.com/2018/personal(1).svg" />
          </div>
          <div className="media__content">
            <p className="benefits-item__title zeta text-center">Sponsored children go from surviving to thriving</p>
            <p className="benefits-item__description">Here at World Vision, <strong>every 60 seconds a family receives the tools to overcome poverty</strong> with help from local staff. Sponsorship helps address the specific needs of each community, empowering your child, their family, and community to become self-sufficient.</p>
          </div>
        </div>
        <div className="benefits__item media media--flipped">
          <div className="media__img">
            <img className="benefits-item__image" src="https://wvusstatic.com/2018/envelope(1).svg" />
          </div>
          <div className="media__content">
            <p className="benefits-item__title zeta text-center">Sponsored children get encouragement</p>
            <p className="benefits-item__description">Your child can experience your love and encouragement through letters and photos, gifts, or even a visit! You can also send your child email and get updates through your My World Vision account. Meanwhile, your monthly sponsorship provides resources and improvements that benefit the whole community.</p>
          </div>
        </div>
        <div className="benefits__item media">
          <div className="media__img">
            <img className="benefits-item__image" src="https://wvusstatic.com/2018/joy(1).svg" />
          </div>
          <div className="media__content">
            <p className="benefits-item__title zeta text-center">Sponsored children experience God’s love</p>
            <p className="benefits-item__description">Our faith in Jesus motivates us to serve <em>all children</em> regardless of race, religion, ethnicity, or gender. We go where other organizations can’t. That means you can too.</p>
          </div>
        </div>
      </section>
    );
  }
}

export default ChildBenefits;
